import { css } from '@emotion/css';

export const dialogStyles = css`
  width: 72rem;
  min-width: 72rem;
`;

export const dialogFooterStyles = css`
  padding-top: 1.6rem !important;
  padding-bottom: 1.6rem !important;
`;

export const fileSelectorStyles = css`
  justify-content: start !important;
`;

export const taskDescriptionStyles = css`
  min-height: 11rem;
`;

export const maxW256 = css`
  max-width: 25.6rem;
`;

export const loaderStyles = css`
  height: 27.2rem;
`;
